"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoOverlay = exports.Video = exports.SuggestionBar = exports.SearchContext = exports.SearchContextManager = exports.SearchBar = exports.PingbackContext = exports.Grid = exports.Gif = exports.Carousel = exports.AttributionOverlay = exports.Attribution = void 0;
var js_util_1 = require("@giphy/js-util");
require("intersection-observer");
var attribution_1 = require("./components/attribution");
Object.defineProperty(exports, "Attribution", { enumerable: true, get: function () { return __importDefault(attribution_1).default; } });
var overlay_1 = require("./components/attribution/overlay");
Object.defineProperty(exports, "AttributionOverlay", { enumerable: true, get: function () { return __importDefault(overlay_1).default; } });
var carousel_1 = require("./components/carousel");
Object.defineProperty(exports, "Carousel", { enumerable: true, get: function () { return __importDefault(carousel_1).default; } });
var gif_1 = require("./components/gif");
Object.defineProperty(exports, "Gif", { enumerable: true, get: function () { return __importDefault(gif_1).default; } });
var grid_1 = require("./components/grid");
Object.defineProperty(exports, "Grid", { enumerable: true, get: function () { return __importDefault(grid_1).default; } });
var pingback_context_manager_1 = require("./components/pingback-context-manager");
Object.defineProperty(exports, "PingbackContext", { enumerable: true, get: function () { return pingback_context_manager_1.PingbackContext; } });
var search_bar_1 = require("./components/search-bar");
Object.defineProperty(exports, "SearchBar", { enumerable: true, get: function () { return __importDefault(search_bar_1).default; } });
var context_1 = require("./components/search-bar/context");
Object.defineProperty(exports, "SearchContextManager", { enumerable: true, get: function () { return __importDefault(context_1).default; } });
Object.defineProperty(exports, "SearchContext", { enumerable: true, get: function () { return context_1.SearchContext; } });
var suggestion_bar_1 = require("./components/search-bar/suggestion-bar");
Object.defineProperty(exports, "SuggestionBar", { enumerable: true, get: function () { return __importDefault(suggestion_bar_1).default; } });
var video_1 = require("./components/video");
Object.defineProperty(exports, "Video", { enumerable: true, get: function () { return __importDefault(video_1).default; } });
__exportStar(require("./components/video/controls/play-pause"), exports);
__exportStar(require("./components/video/controls/volume"), exports);
var video_overlay_1 = require("./components/video/video-overlay");
Object.defineProperty(exports, "VideoOverlay", { enumerable: true, get: function () { return __importDefault(video_overlay_1).default; } });
var version = require('../package.json').version;
// send headers with library type and version
(0, js_util_1.appendGiphySDKRequestHeader)("X-GIPHY-SDK-NAME", 'ReactSDK');
(0, js_util_1.appendGiphySDKRequestHeader)("X-GIPHY-SDK-VERSION", version);
//# sourceMappingURL=index.js.map